import React, { useEffect, useState, useContext, useMemo } from "react";
import { Box, Divider, Grid, Tooltip, Typography, styled } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import { RootState } from "../../../../services/redux/store";
import {
  OutlinedPrimaryButton,
  PrimaryButton,
} from "../../../../components/ui/Button";
import InfoIcon from "./../../../../assets/images/icons/info.png";
import { useDispatch, useSelector } from "react-redux";
import { PaymentTermLoanContext } from "../../../../hooks/context";
import Card from "../../../../components/ui/Card";
import WestIcon from "@mui/icons-material/West";
import postsServices from "../../../../services/api/service/postsService";
import putsService from "../../../../services/api/service/putsService";
import { encryptObject, decrypt, encrypt } from "../../../../utils/crypto";
import { authSelector } from "../../../../services/redux/slices/authSlice";
import { useNavigate, useLocation } from "react-router-dom";
import SuccessIcon from "../../../../assets/icons/success.png";
import FailedIcon from "../../../../assets/icons/failed.png";
import LoaderBackdrop from "../../../../components/ui/LoaderBackdrop";
import { setStatusPopup } from "../../../../services/redux/slices/statusPopupSlice";
import { clearPartPaymentType } from "../../../../services/redux/slices/documentFormSlice";
import { formatNormalIndianRupees } from "../../../../utils/formatting";
import ArrowForwardIosIcon from "@mui/icons-material/KeyboardArrowRight";
import { trackEvent } from "../../../../utils/ga";
import {
  overdueInstructions,
  paymentInstructions,
} from "../../../../data/constant";
// import AmortizationUpdationStatus from "./AmortizationUpdationStatus";
// import NetPrincipalPaidSummary from "./NetPrincipalPaidSummary";
// import { setSelectedIndex } from "../../../../services/redux/slices/tabsSlice";

export interface RowData {
  [key: string]: string | number | null;
}

const PaymentDetailPage = () => {
  const { loanCategory } = useSelector(authSelector);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [isAllRequestClosed, setIsAllRequestClosed] = useState<boolean>(false);
  // const [receiptStatus, setReceiptStatus] = useState<string>("");
  const [fusionStatus, setFusionStatus] = useState<string>("");
  const [amortizationUpdate, setAmortizationUpdate] = useState<string>("");
  // const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
  const [paymentStatus, setPaymentStatus] = useState<string>("");
  const {
    setFormStep,
    userProfile,
    termLoanRequestId,
    selectedLoanNumber,
    cif,
    LoanNo,
    paymentRequestId,
    formTypeValue,
    loanCategoryValue,
    isXsOrSm,
    partPaymentData,
    applicableCharges,
  }: any = useContext(PaymentTermLoanContext);
  const [tableDataLoading, setTableDataLoading] = useState<boolean>(true);
  const [isLinkLoading, setIsLinkLoading] = useState<boolean>(false);
  const [count, setCount] = useState<number>(5);
  const [paymentDataList, setPaymentDataList] = useState<any>([]);
  const [detailsData, setDetailsData] = useState<any>({
    totalAmount: 0,
    amountPaid: 0,
    requestId: "",
    requestStatus: "",
    amortizationUpdate: "",
    chargesPaid:0,
    netPrincipalPaid:0,
  });
  const [paymentReqId, setPaymentReqId] = useState<string>("");
  const columns: any = [
    { id: "amount", label: "Amount" },
    { id: "link", label: "Payment Link" },
    { id: "payment_request", label: "Payment Request Id" },
    { id: "trans_ref", label: "Transaction Ref. No." },
    {
      id: "status",
      label: "PAYMENT Status",
    },
  ];

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Adds smooth scrolling
    });
  }, []);


  // useEffect(() => {
  //   if (!cif && !paymentRequestId && !LoanNo) {
  //     handleInvokePaymentListAPi();
  //   }
  // }, [cif, paymentRequestId, LoanNo]);

  useEffect(() => {
    if (loanCategoryValue) {
      handleUpdateStatus();
    }

    if (!cif && !paymentRequestId && !LoanNo) {
      handleInvokePaymentListAPi();
    }
  }, [cif, LoanNo, paymentRequestId, loanCategoryValue]);

  const handleUpdateStatus = async () => {
    const cleanPath = location.pathname;
    const paymentUpdateDetail = JSON.parse(
      localStorage.getItem("paymentUpdateDetails") || "{}"
    );
    setTableDataLoading(true);
    if ((cif && LoanNo) || paymentRequestId) {
      const check: any = localStorage.getItem("payType")
      const payload: any = {
        cif: encrypt(cif),
        paymentId: encrypt(paymentRequestId),
        lan: encrypt(LoanNo),
        loanCategory: loanCategoryValue?.loanCategoryId,
        business: loanCategoryValue?.businessId,
        paymentType:check? encrypt(check) :
          formTypeValue == "2" ? encrypt("OverDue") : encrypt("PartPayment"),
        nextTermSubID: paymentUpdateDetail?.nextTermSubID,
        nextPaymentAmount: paymentUpdateDetail?.nextPaymentAmount,
      };
      await postsServices
        .addPost(`/api/v1/payment/update-term-loan-payment-status`, payload)
        .then((response: any) => {
          setTableDataLoading(false);
          handleInvokePaymentListAPi();
          setPaymentStatus(response?.data?.data?.requestStatus);
          setPaymentReqId(response?.data?.data?.paymentRequestID);
          if (
            response?.data?.data?.redirection &&
            (response?.data?.data?.requestStatus == "Link Expired" ||
              response?.data?.data?.requestStatus == "Success")
          ) {
            setIsAllRequestClosed(response?.data?.data?.redirection);
            handleSetTimeInterval();
            // if(formTypeValue !== "1") {
            //   handleSetTimeInterval();
            // }
          }

          if (
            response?.data?.data?.redirection &&
            response?.data?.data?.retryCount == 3 &&
            response?.data?.data?.requestStatus == "Failed"
          ) {
            setIsAllRequestClosed(response?.data?.data?.redirection);
            handleSetTimeInterval();
          }
          navigate(cleanPath, { replace: true });
        })
        .catch((error: any) => {
          dispatch(
            setStatusPopup({
              status: "error",
              message: error?.response?.data?.message,
            })
          );
          setTableDataLoading(false);
          navigate(cleanPath, { replace: true });
        });
    }
  };

  const handleLinkProcess = (data: any) => {
    if (
      !data ||
      !data.termSubLoanInfoData ||
      !Array.isArray(data.termSubLoanInfoData)
    ) {
      console.error("Invalid data received for processing payment links.");
      return;
    }
    // Initially disable all links
    const updatedData = data.termSubLoanInfoData.map((item: any) => ({
      ...item,
      isDisabled: true,
    }));
    const firstPendingPayment = data.termSubLoanInfoData.find(
      (item: any) =>
        item.paymentStatus === "Pending" ||
        (item.paymentStatus === "Failed" && item?.retryCount < 3)
    );
    if (firstPendingPayment) {
      // Paid Amount + Upcoming Link value >= 3 times EMI + Applicable charges.
      const formulaValue =
        data.amountPaid + firstPendingPayment.amount >=
        3 * (partPaymentData?.[0]?.newEmiAmount / 100) + applicableCharges;

      // Enable links based on the condition
      let firstEnabled = false;
      updatedData.forEach((item: any) => {
        if (
          !firstEnabled &&
          (item.paymentStatus === "Pending" ||
            (item.paymentStatus === "Failed" && item?.retryCount < 3))
        ) {
          item.isDisabled = false;
          firstEnabled = true;
        }
      });
    } else {
      console.warn("No pending or retryable payment found.");
    }
    // Persist the updated data in localStorage and update state immediately
    try {
      setPaymentDataList(updatedData);
      setTableDataLoading(false);
    } catch (error) {
      console.error("Failed to persist payment data in localStorage:", error);
    }
  };

  /**
   * Handles the invocation of the payment list API.
   *
   * This function asynchronously calls the `getPosts` method from `postsServices`
   * to fetch the term loan listing data for a specific term loan request ID.
   * On a successful response, it updates the payment data list state with the
   * retrieved term sub-loan information data. If an error occurs during the API
   * call, it logs the error to the console.
   *
   * @async
   * @function handleInvokePaymentListAPi
   * @returns {Promise<void>} A promise that resolves when the API call is complete.
   */
  const handleInvokePaymentListAPi = async (): Promise<void> => {
    setTableDataLoading(true);
    await postsServices
      .getPosts(`/api/v1/payment/term-loan-listing/${termLoanRequestId}`)
      .then((response: any) => {
        setDetailsData({
          totalAmount: response?.data?.data?.totalAmount,
          amountPaid: response?.data?.data?.amountPaid,
          requestId: response?.data?.data?.requestId,
          requestStatus: response?.data?.data?.requestStatus,
          amortizationUpdate: response?.data?.data?.amortizationUpdate,
          chargesPaid: response?.data?.data?.chargesPaid || 0,
          netPrincipalPaid: response?.data?.data?.netPrincipalPaid || 0,
        });

        if (formTypeValue == "1") {
          handleLinkProcess(response?.data?.data);
        } else if (formTypeValue == "2") {
          setPaymentDataList(response?.data?.data?.termSubLoanInfoData);
          setTableDataLoading(false);
        }
      })
      .catch((error: any) => {
        dispatch(
          setStatusPopup({
            status: "error",
            message: error?.response?.data?.message,
          })
        );
        setTableDataLoading(false);
      });
  };

  // Load persisted payment data from localStorage on component mount
  // useEffect(() => {
  //   const persistedData = localStorage.getItem("paymentDataList");
  //   if (persistedData) {
  //     setPaymentDataList(JSON.parse(persistedData));
  //   }
  // }, []);

  /**
   * Handles the click event to initiate a payment.
   *
   * @param {number} id - The identifier for the payment.
   *
   * This function constructs a payload with necessary payment details,
   * encrypts the payload, and sends a POST request to the payment API.
   *
   * The payload includes:
   * - cif: Customer Identification File number (decrypted)
   * - amount: Total payment amount
   * - lan: Loan account number
   * - paymentType: Type of payment (e.g., PartPayment)
   * - initiatedBy: ID of the user initiating the payment (decrypted)
   * - loanType: Type of the loan
   * - termLoanSubId: Sub ID of the term loan
   *
   * The encrypted payload is sent to the endpoint `/api/v1/payment/term-loan-request`.
   *
   * On success, the response is logged to the console.
   * On failure, the error is logged to the console.
   */
  const handleClickToPay = async (id: number, amount: number) => {
    const eventName = formTypeValue == "1" ? "Dash_Pay_PartPay_Paynow_Link" : "Dash_Pay_Overdue_Paynow_Link";
    trackEvent(eventName, decrypt(userProfile?.id), {
      label: eventName,
      category: eventName,
      action: eventName,
    });
    setIsLinkLoading(true);
    let payType: any;
    if(localStorage.getItem("payType")) {
      payType = localStorage.getItem("payType")
    } else if(formTypeValue === "2") {
      payType = "OverDue";
    } else if(formTypeValue === "1") {
      payType = "PartPayment"
    }
    const payload: any = {
      cif: decrypt(userProfile?.cifNumber),
      amount: amount,
      lan: selectedLoanNumber,
      paymentType: payType,
      initiatedBy: decrypt(userProfile?.id),
      loanType: loanCategoryValue?.loanTypeName,
      termLoanSubId: id,
    };
    localStorage.setItem("subId", id.toString());
    const findIndexVal = paymentDataList.findIndex((elem: any) => {
      return elem?.termLoanSubId == Number(id);
    });
    const valueObj = {
      nextPaymentAmount: paymentDataList?.[findIndexVal + 1]?.amount,
      nextTermSubID: paymentDataList?.[findIndexVal + 1]?.termLoanSubId,
    };
    localStorage.setItem("paymentUpdateDetails", JSON.stringify(valueObj));
    const encryptedData = encryptObject(payload);
    await postsServices
      .addPost("/api/v1/payment/term-loan-request", {
        data: encryptedData,
      })
      .then((response: any) => {
        setIsLinkLoading(false);
        window.location.href = response?.data?.data;
      })
      .catch((error: any) => {
        setIsLinkLoading(false);
        dispatch(
          setStatusPopup({
            status: "error",
            message: error?.response?.data?.message,
          })
        );
      });
  };

  /**
   * Handles navigation to the history page.
   *
   * This function sets a timeout of 5 seconds before navigating to the current path
   * and optionally removing the "termLoanRequestId" from local storage. It also
   * resets the form step to -1.
   *
   * @function
   * @name handleNavigateToHistory
   * @returns {void}
   */
  const handleNavigateToHistory = (): void => {
    dispatch(clearPartPaymentType());
    const cleanPath = location.pathname;
    navigate(cleanPath, { replace: true });
    if (localStorage.getItem("termLoanRequestId")) {
      localStorage.removeItem("termLoanRequestId");
      setFormStep(-1);
    } else {
      setFormStep(-1);
    }
  };

  /**
   * Sets a time interval that decrements the count state by 1 every second.
   * When the count reaches 0, the interval is cleared and the user is navigated to the history page.
   *
   * @returns {NodeJS.Timeout} The interval ID that can be used to clear the interval.
   */
  const handleSetTimeInterval = (): NodeJS.Timeout => {
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev === 0) {
          clearInterval(interval);
          handleNavigateToHistory();
        }
        return prev - 1;
      });
    }, 1000);
    return interval;
  };

  const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    background: "white",
    boxShadow: "0px 4px 18px rgba(0, 0, 0, 0.07)",
    borderRadius: "6px",
  }));

  const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
    padding: "10px",
    color: "#168794",
    fontSize: "clamp(10px, 1.2vw, 12px)",
    fontWeight: 600,
    textTransform: "capitalize",
    fontFamily: "Jost",
  }));

  const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
    padding: "10px",
    color: "#707579",
    fontSize: "clamp(10px, 1.2vw, 12px)",
    fontWeight: 500,
    lineHeight: "22px",
    alignItems: "center",
  }));

  const StatusBadge = styled("span")<{
    statusColor: string;
    backgroundColor: string;
  }>(({ statusColor, backgroundColor }) => ({
    color: statusColor,
    textTransform: "capitalize",
    backgroundColor,
    padding: "5px 10px",
    borderRadius: "4px",
  }));

  // useEffect(() => {
  //   if(detailsData?.requestId && formTypeValue === "1") {
  //       fetchReceiptStatus();
  //   }
  // }, [detailsData?.requestId, formTypeValue])

  // const fetchReceiptStatus = async () => {
  //   setIsRefreshing(true)
  //   const payload = {
  //     termLoanRequestId: encrypt(detailsData?.requestId)
  //   }
  //    await postsServices
  //       .addPost(`/api/v1/payment/receipt-status`, payload)
  //       .then((response: any) => {
  //         if(response && response?.status === 200) {
  //           setReceiptStatus(response?.data?.data?.receiptingStatus)
  //           setFusionStatus(response?.data?.data?.fusionStatus)
  //           setAmortizationUpdate(response?.data?.data?.amortizationUpdate)
  //           setIsRefreshing(false);
  //         }
  //       })
  //       .catch((error: any) => {
  //         console.log(error?.response?.data?.message || "Something went wrong!")
  //         setIsRefreshing(false);
  //       })
  // }

  const handleCancelRequestModal = () => {
    dispatch(
      setStatusPopup({
        status: "info",
        title: "Cancel Request?",
        message: "Are you sure you want to cancel this request?",
        isFunction: true,
        locationFunction: () => handleCancelRequest(),
      })
    );
  };

  const handleCancelRequest = async () => {
    setTableDataLoading(true);
    await putsService
      .put(`/api/v1/payment/term-loan-cancel-listing/${termLoanRequestId}`)
      .then((response: any) => {
        setPaymentStatus("All_Cancelled");
        handleSetTimeInterval();
        handleInvokePaymentListAPi();
      })
      .catch((error: any) => {
        setTableDataLoading(false);
        dispatch(
          setStatusPopup({
            status: "error",
            message: error?.response?.data?.message,
          })
        );
      });
  };

  /**
   * Determines if the request is cancelled based on the payment data list and request status.
   *
   * @returns {boolean} - Returns `false` if any payment status is not "Pending" or if the request status is "Expired".
   *                      Otherwise, returns `true`.
   *
   * @param {Array} paymentDataList - List of payment data objects.
   * @param {Object} detailsData - Object containing details data.
   * @param {string} detailsData.requestStatus - The status of the request.
   */
  const isRequestCancelled = useMemo(() => {
    const stateValue = paymentDataList.some(
      (elem: any) => elem.paymentStatus !== "Pending"
    );
    if (detailsData.requestStatus == "Expired") {
      return false;
    }
    if (stateValue) {
      return false;
    }
    return true;
  }, [paymentDataList, detailsData.requestStatus]);

  const AMORT_LIST: any = ["In Progress", "No Payment Received"];

  return (
    <>
      <LoaderBackdrop open={isLinkLoading} />
      <Grid item xs={12} sm={12}>
        <Box>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "14px",
              letterSpacing: "1px",
              color: "#168794",
            }}
          >
            Payment
          </Typography>
        </Box>
        <Box className="dashboard-container mt-10">
          <Card>
            <Box>
              <Typography className="section-sub-heading mt-10">
                Terms & Conditions:
              </Typography>
            </Box>
            <Box>
              <ul>
                {formTypeValue == 2
                  ? (() => {
                      return (
                        <>
                          <li
                            style={{
                              color: "rgba(75, 70, 92, 0.8)",
                              fontSize: isXsOrSm ? "10px" : "13px",
                              fontWeight: isXsOrSm ? "400" : "600",
                              lineHeight: isXsOrSm ? "12px" : "",
                            }}
                          >
                            The Request ID for overdue amount has been created.
                            Please complete the payment within 12 hours.
                          </li>
                          {overdueInstructions.map((item: any) => (
                            <li
                              style={{
                                color: "rgba(75, 70, 92, 0.8)",
                                fontSize: isXsOrSm ? "10px" : "13px",
                                fontWeight: isXsOrSm ? "400" : "600",
                                lineHeight: isXsOrSm ? "12px" : "",
                              }}
                            >
                              {item}
                            </li>
                          ))}
                        </>
                      );
                    })()
                  : (() => {
                      return (
                        <>
                          <li
                            style={{
                              color: "rgba(75, 70, 92, 0.8)",
                              fontSize: isXsOrSm ? "10px" : "13px",
                              fontWeight: isXsOrSm ? "400" : "600",
                              lineHeight: isXsOrSm ? "12px" : "",
                            }}
                          >
                            The Request ID for part payment amount has been
                            created. Please complete the payment within 12
                            hours.
                          </li>
                          {paymentInstructions.map((item: any) => (
                            <li
                              style={{
                                color: "rgba(75, 70, 92, 0.8)",
                                fontSize: isXsOrSm ? "10px" : "13px",
                                fontWeight: isXsOrSm ? "400" : "600",
                                lineHeight: isXsOrSm ? "12px" : "",
                              }}
                            >
                              {item}
                            </li>
                          ))}
                        </>
                      );
                    })()}
              </ul>
            </Box>
          </Card>
        </Box>
        {paymentStatus && (
          <Box sx={{ paddingTop: "20px" }}>
            <Card>
              <Grid container item sx={{ padding: isXsOrSm ? "10px" : "0px" }}>
                <Grid item>
                  <img
                    src={
                      paymentStatus == "Success" ||
                      paymentStatus == "All_Cancelled"
                        ? SuccessIcon
                        : FailedIcon
                    }
                    alt=""
                  />
                </Grid>
                <Grid item sm={11} lg={11} xs={10} sx={{ paddingLeft: "12px" }}>
                  {paymentStatus == "Success" ||
                  paymentStatus == "All_Cancelled" ? (
                    <>
                      <Typography
                        sx={{
                          fontWeight: "600",
                          fontSize: "13px",
                          lineHeight: "19px",
                          letterSpacing: "1px",
                        }}
                      >
                        {paymentStatus == "All_Cancelled" &&
                          "Request canceled successfully!"}
                        {paymentStatus == "Success" && "Payment Successful"}
                      </Typography>
                      {paymentStatus == "Success" && (
                        <Typography
                          sx={{
                            fontWeight: "500",
                            fontSize: "11px",
                            lineHeight: "19px",
                            letterSpacing: "1px",
                            color: "#28C76F",
                          }}
                        >
                          Payment successful for ID: {paymentReqId}
                        </Typography>
                      )}

                      {/* {paymentStatus == "All_Cancelled" && formTypeValue !== "1" && ( */}
                      {paymentStatus == "All_Cancelled" && (
                        <Typography
                          sx={{
                            fontWeight: "500",
                            fontSize: "10px",
                            lineHeight: "19px",
                            letterSpacing: "1px",
                            color: "#28C76F",
                          }}
                        >
                          You will be redirected to the payment page with
                          request history in {count} secs
                        </Typography>
                      )}
                    </>
                  ) : (
                    <>
                      <Typography
                        sx={{
                          fontWeight: "600",
                          fontSize: "13px",
                          lineHeight: "19px",
                          letterSpacing: "1px",
                        }}
                      >
                        {paymentStatus == "Failed" && "Payment Failed!"}
                        {paymentStatus == "Expired" && "Payment Expired!"}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "10px",
                          lineHeight: "19px",
                          letterSpacing: "1px",
                          color: "#FF4C51",
                        }}
                      >
                        {(paymentStatus == "Failed" ||
                          paymentStatus == "Expired") && (
                          <>
                            Payment {paymentStatus == "Failed" && "failed"}{" "}
                            {paymentStatus == "Expired" && "expired"} for ID:{" "}
                            {paymentReqId}.{" "}
                            {paymentStatus == "Failed" && (
                              <>
                                {Number(
                                  3 -
                                    paymentDataList.filter(
                                      (pdata: any) =>
                                        pdata.termLoanSubId ==
                                        localStorage.getItem("subId")
                                    )?.[0]?.retryCount
                                )}{" "}
                                retry payment attempts left.
                              </>
                            )}
                          </>
                        )}
                      </Typography>
                    </>
                  )}
                  {/* {isAllRequestClosed && formTypeValue !== "1" && ( */}
                  {isAllRequestClosed && (
                    <>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "10px",
                          lineHeight: "19px",
                          letterSpacing: "1px",
                          color: "#000000",
                        }}
                      >
                        All payments completed and request marked as closed. You
                        will be redirected to the payment page with request
                        history in{" "}
                        <span style={{ color: "#00CFE8" }}> {count} secs </span>
                      </Typography>
                    </>
                  )}
                </Grid>
              </Grid>
            </Card>
          </Box>
        )}

         {/* {(detailsData?.requestStatus === "Expired" ||
          detailsData?.requestStatus === "Closed" ||
          detailsData?.requestStatus === "Cancelled") && formTypeValue === "1" &&
          <Box
            className={`${
              isXsOrSm ? "dashboard-container-mobile" : "dashboard-container"
            }  mt-20`}
          >
            <AmortizationUpdationStatus
              status={receiptStatus}
              fusionStatus={fusionStatus}
              amortizationUpdate={amortizationUpdate}
              onRefresh={fetchReceiptStatus}
              isRefreshing={isRefreshing}
              onViewDocuments={() => dispatch(setSelectedIndex(3))}
            />
          </Box>} */}

        <Box
          className={`${
            isXsOrSm ? "dashboard-container-mobile" : "dashboard-container"
          }  mt-20`}
        >
          <StyledTableContainer>
            {isXsOrSm ? (
              <>
                <Grid container spacing={2} sx={{ padding: "24px" }}>
                  <Grid item xs={12}>
                    <Typography className="section-sub-heading">
                      PAYMENT DETAILS
                    </Typography>
                  </Grid>

                  <Grid item xs={4} sm={6} md={4}>
                    <Typography className="headerLabelMobile">
                      Request ID
                    </Typography>
                    <Typography className="headerValueMobile">
                      {tableDataLoading ? (
                        <Skeleton variant="text" width="100px" height="24px" />
                      ) : (
                        <> {detailsData?.requestId} </>
                      )}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={6}
                    md={4}
                    style={{ paddingLeft: "10%" }}
                  >
                    <Typography className="headerLabelMobile">
                      Total Amount
                    </Typography>
                    <Typography className="headerValueMobile">
                      {tableDataLoading ? (
                        <Skeleton variant="text" width="100px" height="24px" />
                      ) : (
                        <>
                          {" "}
                          {String(
                            formatNormalIndianRupees(detailsData?.totalAmount)
                          )}{" "}
                        </>
                      )}
                    </Typography>
                  </Grid>
                  {/* {formTypeValue !== "1" && <Grid */}
                  <Grid
                    item
                    xs={4}
                    sm={6}
                    md={4}
                    style={{ paddingLeft: "10%" }}
                  >
                    <Typography className="headerLabelMobile">
                      Amount Paid
                    </Typography>
                    <Typography className="headerValueMobile">
                      {tableDataLoading ? (
                        <Skeleton variant="text" width="100px" height="24px" />
                      ) : (
                        <>
                          {" "}
                          {String(
                            formatNormalIndianRupees(detailsData?.amountPaid)
                          )}{" "}
                        </>
                      )}
                    </Typography>
                  </Grid>
                  {/* // */}
                  <Grid item xs={4} sm={6} md={4}>
                    <Typography className="headerLabelMobile">
                      Request Status
                    </Typography>
                    <Typography
                      className="headerValueMobile"
                      style={{
                        color:
                          detailsData?.requestStatus == "Open"
                            ? "#28C76F"
                            : "#FF4C51",
                      }}
                    >
                      {tableDataLoading ? (
                        <Skeleton variant="text" width="100px" height="24px" />
                      ) : (
                        <>
                          {" "}
                          {detailsData?.requestStatus}{" "}
                          {(detailsData?.requestStatus === "Closed" ||
                            detailsData?.requestStatus === "Expired") &&
                            formTypeValue == "1" && (
                              <Tooltip
                                placement="top"
                                enterTouchDelay={50}
                                title={(() => {
                                  const noPaymentReceived =
                                    (detailsData.requestStatus === "Closed" ||
                                      detailsData.requestStatus ===
                                        "Expired") &&
                                    detailsData.amortizationUpdate ===
                                      "No Payment Received";
                                  const amortizationInProgress =
                                    (detailsData.requestStatus === "Closed" ||
                                      detailsData.requestStatus ===
                                        "Expired") &&
                                    detailsData.amortizationUpdate ===
                                      "In Progress";
                                  const amortizationDone =
                                    (detailsData.requestStatus === "Closed" ||
                                      detailsData.requestStatus ===
                                        "Expired") &&
                                    (detailsData.amortizationUpdate ===
                                      "Done. EMI Reduced" ||
                                      detailsData.amortizationUpdate ===
                                        "Done. Tenure Reduced");
                                  return noPaymentReceived
                                    ? "No payment received"
                                    : amortizationInProgress
                                    ? "Amortization updation initiated for payment received"
                                    : amortizationDone
                                    ? "Amortization updated"
                                    : "";
                                })()}
                              >
                                <img
                                  src={InfoIcon}
                                  alt="Status"
                                  className="imgicon"
                                />
                              </Tooltip>
                            )}
                        </>
                      )}
                    </Typography>
                  </Grid>
                  {formTypeValue == "1" && (
                    <Grid item xs={6} sm={6} md={4}>
                      <Typography className="headerLabelMobile">
                        Amortization Updation
                      </Typography>
                      <Typography
                        className="headerValueMobile"
                        style={{
                          color: AMORT_LIST.includes(
                            detailsData?.amortizationUpdate
                          )
                            ? "#FF9F43"
                            : "#28C76F",
                        }}
                      >
                        {tableDataLoading ? (
                          <Skeleton
                            variant="text"
                            width="100px"
                            height="24px"
                          />
                        ) : (
                          <> {detailsData?.amortizationUpdate} </>
                        )}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </>
            ) : (
              <>
                <Box sx={{ padding: "30px" }}>
                  <Typography className="section-sub-heading">
                    PAYMENT DETAILS
                  </Typography>
                  <Box
                    sx={{
                      paddingTop: "14px",
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: "16px", // Adjust gap size as needed
                    }}
                  >
                    <Box sx={{ flex: "1 1 200px", minWidth: "150px" }}>
                      <Typography className="insidePageLable">
                        Request ID
                      </Typography>
                      <Typography className="insidePageValue">
                        {tableDataLoading ? (
                          <Skeleton
                            variant="text"
                            width="120px"
                            height="24px"
                          />
                        ) : (
                          <> {detailsData?.requestId} </>
                        )}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: "1 1 200px", minWidth: "150px" }}>
                      <Typography className="insidePageLable">
                        Total Amount
                      </Typography>
                      <Typography className="insidePageValue">
                        {tableDataLoading ? (
                          <Skeleton
                            variant="text"
                            width="120px"
                            height="24px"
                          />
                        ) : (
                          <>
                            {" "}
                            {formatNormalIndianRupees(
                              detailsData?.totalAmount
                            )}{" "}
                          </>
                        )}
                      </Typography>
                    </Box>
                    {/* {formTypeValue !== "1" &&  */}
                    <Box sx={{ flex: "1 1 200px", minWidth: "150px" }}>
                      <Typography className="insidePageLable">
                        Amount Paid
                      </Typography>
                      <Typography className="insidePageValue">
                        {tableDataLoading ? (
                          <Skeleton
                            variant="text"
                            width="120px"
                            height="24px"
                          />
                        ) : (
                          <>
                            {" "}
                            {formatNormalIndianRupees(
                              detailsData?.amountPaid
                            )}{" "}
                          </>
                        )}
                      </Typography>
                    </Box>
                    {/* } */}
                    <Box sx={{ flex: "1 1 200px", minWidth: "150px" }}>
                      <Typography className="insidePageLable">
                        Request Status
                      </Typography>
                      <Typography
                        className="insidePageValue"
                        style={{
                          fontWeight: "500 !important",
                          color:
                            detailsData?.requestStatus == "Open"
                              ? "#28C76F"
                              : "#FF4C51",
                        }}
                      >
                        {tableDataLoading ? (
                          <Skeleton
                            variant="text"
                            width="120px"
                            height="24px"
                          />
                        ) : (
                          <>
                            {" "}
                            {detailsData?.requestStatus}{" "}
                            {(detailsData?.requestStatus === "Closed" ||
                              detailsData?.requestStatus === "Expired") &&
                              formTypeValue == "1" && (
                                <Tooltip
                                  placement="top"
                                  title={(() => {
                                    const noPaymentReceived =
                                      (detailsData.requestStatus === "Closed" ||
                                        detailsData.requestStatus ===
                                          "Expired") &&
                                      detailsData.amortizationUpdate ===
                                        "No Payment Received";
                                    const amortizationInProgress =
                                      (detailsData.requestStatus === "Closed" ||
                                        detailsData.requestStatus ===
                                          "Expired") &&
                                      detailsData.amortizationUpdate ===
                                        "In Progress";
                                    const amortizationDone =
                                      (detailsData.requestStatus === "Closed" ||
                                        detailsData.requestStatus ===
                                          "Expired") &&
                                      (detailsData.amortizationUpdate ===
                                        "Done. EMI Reduced" ||
                                        detailsData.amortizationUpdate ===
                                          "Done. Tenure Reduced");

                                    return noPaymentReceived
                                      ? "No payment received"
                                      : amortizationInProgress
                                      ? "Amortization updation initiated for payment received"
                                      : amortizationDone
                                      ? "Amortization updated"
                                      : "";
                                  })()}
                                >
                                  <img
                                    src={InfoIcon}
                                    alt="Status"
                                    className="imgicon"
                                  />
                                </Tooltip>
                              )}{" "}
                          </>
                        )}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: "1 1 200px", minWidth: "200px" }}>
                      {formTypeValue == "1" && (
                        <>
                          <Typography className="insidePageLable">
                            Amortization Updation
                          </Typography>
                          <Typography
                            className="insidePageValue"
                            style={{
                              fontWeight: "500 !important",
                              color: AMORT_LIST.includes(
                                detailsData?.amortizationUpdate
                              )
                                ? "#FF9F43"
                                : "#28C76F",
                            }}
                          >
                            {tableDataLoading ? (
                              <Skeleton
                                variant="text"
                                width="120px"
                                height="24px"
                              />
                            ) : (
                              <> {detailsData?.amortizationUpdate} </>
                            )}
                          </Typography>
                        </>
                      )}
                    </Box>
                  </Box> 
                </Box>
              </>
            )}
          {/* {formTypeValue === "1" && <Box sx={{ 
              margin: { xs: "0px 10px 10px 10px" },
              marginTop: { xs: "-10px !important", md: "-30px !important" }
            }}>
              <NetPrincipalPaidSummary
                amountPaid={formatNormalIndianRupees(
                  detailsData?.amountPaid
                )}
                chargesPaid={formatNormalIndianRupees(
                  detailsData?.chargesPaid
                )}
                netPrincipalPaid={formatNormalIndianRupees(
                  detailsData?.netPrincipalPaid
                )}
              />
            </Box>} */}

            <Divider />

            {isXsOrSm ? (
              <>
                <Grid
                  container
                  spacing={1}
                  sx={{ padding: "24px" }}
                  className={`${
                    isXsOrSm
                      ? "dashboard-container-mobile"
                      : "dashboard-container"
                  } `}
                >
                  {tableDataLoading ? (
                    <>
                      <React.Fragment>
                        <Grid item xs={6}>
                          <Typography className="insidePageLableMobile">
                            Payment Request Id
                          </Typography>
                          <Typography className="insidePageValueMobile">
                            <Skeleton
                              variant="text"
                              width="60px"
                              height="24px"
                            />
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography className="insidePageLableMobile">
                            Transaction Ref. No.
                          </Typography>
                          <Typography className="insidePageValueMobile">
                            <Skeleton
                              variant="text"
                              width="60px"
                              height="24px"
                            />
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography className="insidePageLableMobile">
                            Amount
                          </Typography>
                          <Typography
                            className="insidePageValueMobile"
                            sx={{ fontSize: "13px !important" }}
                          >
                            <Skeleton
                              variant="text"
                              width="60px"
                              height="24px"
                            />
                          </Typography>
                        </Grid>
                        <Grid item xs={5} alignContent={"flex-end"}>
                          <Typography className="insidePageLableMobile">
                            Payment Status
                          </Typography>
                          <Typography className="insidePageValueMobile">
                            <Skeleton
                              variant="text"
                              width="60px"
                              height="24px"
                            />
                          </Typography>
                        </Grid>
                        <Grid item xs={4} alignContent={"flex-end"}>
                          <Typography className="insidePageValueMobile">
                            <Skeleton
                              variant="text"
                              width="50px"
                              height="24px"
                            />
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>
                      </React.Fragment>
                    </>
                  ) : (
                    <>
                      {paymentDataList?.map((elem: any, index: number) => (
                        <React.Fragment key={index}>
                          <Grid item xs={7}>
                            <Typography className="insidePageLableMobile">
                              Payment Request Id
                            </Typography>
                            <Typography className="insidePageValueMobile">
                              {elem?.paymentRequestId}
                            </Typography>
                          </Grid>

                          <Grid item xs={4}>
                            <Typography className="insidePageLableMobile">
                              Transaction Ref. No.
                            </Typography>
                            <Typography
                              className="insidePageValueMobile"
                              style={{ wordBreak: "break-word" }}
                            >
                              {elem?.transactionReferenceNo}
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="insidePageLableMobile">
                              Amount
                            </Typography>
                            <Typography
                              className="insidePageValueMobile"
                              // sx={{ fontSize: "14px !important" }}
                            >
                              {String(formatNormalIndianRupees(elem?.amount))}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} alignContent={"flex-end"}>
                            <Typography
                              className="insidePageLableMobile"
                              // sx={{ fontSize: "14px !important" }}
                            >
                              Status
                            </Typography>
                            <Typography className="insidePageValueMobile">
                              {elem?.paymentStatus == "Success" && (
                                <>
                                  <span
                                    style={{
                                      color: "#28C76F",
                                      textTransform: "capitalize",
                                      // fontSize: "13px",
                                    }}
                                  >
                                    {elem?.paymentStatus}
                                  </span>
                                </>
                              )}

                              {(elem?.paymentStatus == "Failed" ||
                                elem?.paymentStatus == "Cancelled" ||
                                elem?.paymentStatus == "Link Expired" ||
                                elem?.paymentStatus == "Link Disabled") && (
                                <>
                                  <span
                                    style={{
                                      color: "#EA5455",
                                      textTransform: "capitalize",
                                      // fontSize: "13px",
                                    }}
                                  >
                                    {elem.paymentStatus}
                                    {elem?.paymentStatus == "Link Disabled" && (
                                      <Tooltip
                                        title={
                                          "Amount too low for part payment"
                                        }
                                        enterTouchDelay={50}
                                        placement="top"
                                      >
                                        <img
                                          src={InfoIcon}
                                          alt="Status"
                                          style={{
                                            height: "15px",
                                            width: "15px",
                                            marginLeft: "5px",
                                            position: "relative",
                                            top: "4px",
                                          }}
                                        />
                                      </Tooltip>
                                    )}
                                  </span>
                                </>
                              )}

                              {elem?.paymentStatus == "Pending" && (
                                <>
                                  <span
                                    style={{
                                      color: "#EF7327",
                                      textTransform: "capitalize",
                                      // fontSize: "13px",
                                    }}
                                  >
                                    {elem?.paymentStatus}
                                  </span>
                                </>
                              )}
                            </Typography>
                          </Grid>

                          <Grid item xs={4} alignContent={"flex-end"}>
                            <Typography className="insidePageValueMobile">
                              {(elem?.retryCount == 3 &&
                                elem?.paymentStatus == "Failed") ||
                              elem?.paymentStatus == "Success" ||
                              elem?.paymentStatus == "Cancelled" ||
                              elem?.paymentStatus == "Link Expired" ||
                              detailsData.requestStatus == "Expired" ||
                              detailsData.requestStatus == "Closed" ||
                                elem?.isDisabled ? (
                                <span
                                  className="click-to-pay-disabled-mobile"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  Pay Now{" "}
                                  <ArrowForwardIosIcon
                                    sx={{ fontSize: "14px" }}
                                  />
                                </span>
                              ) : (
                                <span
                                  className="click-to-pay-mobile"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() =>
                                    handleClickToPay(
                                      elem?.termLoanSubId,
                                      elem?.amount
                                    )
                                  }
                                >
                                  {elem?.retryCount == 0 &&
                                  elem?.paymentStatus == "Pending"
                                    ? "Pay Now"
                                    : elem?.retryCount >= 1 &&
                                      elem?.paymentStatus == "Failed"
                                    ? "Pay Again"
                                    : "Pay Again"}
                                  <ArrowForwardIosIcon
                                    sx={{ fontSize: "14px" }}
                                  />
                                </span>
                              )}
                            </Typography>
                          </Grid>

                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </Grid>
              </>
            ) : (
              <>
                <Table aria-label="sticky table">
                  <TableHead sx={{ height: "64px" }}>
                    <TableRow>
                      {columns?.map((column: any) => (
                        <StyledTableCellHead
                          key={column.id}
                          sx={{
                            paddingLeft: "24px",
                          }}
                        >
                          {column.label.toUpperCase() || "-"}
                        </StyledTableCellHead>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ height: "64px" }}>
                    {tableDataLoading ? (
                      <>
                        {Array.from({ length: 4 }).map((_, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="80px"
                                height="24px"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="120px"
                                height="24px"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="140px"
                                height="24px"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="160px"
                                height="24px"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="rectangular"
                                width="100px"
                                height="32px"
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </>
                    ) : (
                      <>
                        {paymentDataList?.map((elem: any) => (
                          <>
                            <TableRow role="checkbox" tabIndex={-1}>
                              <StyledTableCellBody
                                sx={{
                                  paddingLeft: "24px",
                                }}
                              >
                                {formatNormalIndianRupees(elem.amount)}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  paddingLeft: "24px",
                                }}
                              >
                                {(elem?.retryCount == 3 &&
                                  elem?.paymentStatus == "Failed") ||
                                elem?.paymentStatus == "Success" ||
                                elem?.paymentStatus == "Cancelled" ||
                                elem?.paymentStatus == "Link Expired" ||
                                detailsData.requestStatus == "Expired" ||
                                detailsData.requestStatus == "Closed" ||
                                elem?.isDisabled ? (
                                  <>
                                    <span className="click-to-pay-disabled">
                                      Click to Pay Now
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <span
                                      className="click-to-pay"
                                      onClick={() =>
                                        handleClickToPay(
                                          elem?.termLoanSubId,
                                          elem.amount
                                        )
                                      }
                                    >
                                      {elem?.retryCount == 0 &&
                                      elem?.paymentStatus == "Pending"
                                        ? "Click to Pay Now"
                                        : elem?.retryCount >= 1 &&
                                          elem?.paymentStatus == "Failed"
                                        ? "Click to Retry Payment"
                                        : "Click to Retry Payment"}
                                    </span>
                                  </>
                                )}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  paddingLeft: "24px",
                                }}
                              >
                                {elem.paymentRequestId}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  paddingLeft: "24px",
                                }}
                              >
                                {elem?.transactionReferenceNo}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  paddingLeft: "24px",
                                }}
                              >
                                {elem.paymentStatus == "Success" && (
                                  <StatusBadge
                                    statusColor="#28C76F"
                                    backgroundColor="rgba(40, 199, 111, 0.2)"
                                  >
                                    <span
                                      style={{
                                        color: "#28C76F",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {elem.paymentStatus}
                                    </span>
                                  </StatusBadge>
                                )}

                                {(elem.paymentStatus == "Failed" ||
                                  elem?.paymentStatus == "Cancelled" ||
                                  elem?.paymentStatus == "Link Expired" ||
                                  elem?.paymentStatus == "Link Disabled") && (
                                  <StatusBadge
                                    statusColor="#FF4C51"
                                    backgroundColor="rgba(234, 84, 85, 0.2)"
                                  >
                                    <span
                                      style={{
                                        color: "#EA5455",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {elem.paymentStatus}
                                      {elem?.paymentStatus ==
                                        "Link Disabled" && (
                                        <Tooltip
                                          title={
                                            "Amount too low for part payment"
                                          }
                                          enterTouchDelay={50}
                                          placement="top"
                                        >
                                          <img
                                            src={InfoIcon}
                                            alt="Status"
                                            style={{
                                              height: "15px",
                                              width: "15px",
                                              marginLeft: "5px",
                                              position: "relative",
                                              top: "4px",
                                            }}
                                          />
                                        </Tooltip>
                                      )}
                                    </span>
                                  </StatusBadge>
                                )}

                                {elem.paymentStatus == "Pending" && (
                                  <StatusBadge
                                    statusColor="#F36F21"
                                    backgroundColor="rgba(243, 111, 33, 0.2)"
                                  >
                                    <span
                                      style={{
                                        color: "#EF7327",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {elem.paymentStatus}
                                    </span>
                                  </StatusBadge>
                                )}
                              </StyledTableCellBody>
                            </TableRow>
                          </>
                        ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </>
            )}

            <Box sx={{ padding: "30px" }}>
              <Grid
                container
                justifyContent="center" // Center the buttons horizontally
                alignItems="center"
                spacing={2} // Maintain spacing between items
              >
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  container
                  justifyContent="left"
                >
                  <OutlinedPrimaryButton
                    width={isXsOrSm ? "100px" : "129px"}
                    height={isXsOrSm ? "30px" : "42px"}
                    fullWidth={true}
                    onClick={() => {
                      dispatch(clearPartPaymentType());
                      const cleanPath = location.pathname;
                      navigate(cleanPath, { replace: true });
                      if (localStorage.getItem("termLoanRequestId")) {
                        localStorage.removeItem("termLoanRequestId");
                        setFormStep(-1);
                      } else {
                        setFormStep(-1);
                      }
                    }}
                  >
                    <WestIcon sx={{ fontSize: isXsOrSm ? "15px" : "20px" }} />{" "}
                    Previous
                  </OutlinedPrimaryButton>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  container
                  justifyContent="right"
                >
                  {!tableDataLoading && (
                    <>
                      {isRequestCancelled && (
                        <PrimaryButton
                          fullWidth={true}
                          width={isXsOrSm ? "150px" : "152px"}
                          height={isXsOrSm ? "30px" : "42px"}
                          onClick={() => handleCancelRequestModal()}
                          fontSize={isXsOrSm ? "13px" : "15px"}
                        >
                          {" "}
                          Cancel Request{" "}
                        </PrimaryButton>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
          </StyledTableContainer>
        </Box>
      </Grid>
    </>
  );
};

export default PaymentDetailPage;
